var _module_exports = "<div class=\"content-inner-wrapper\" ng-transclude></div>\n\n\n";;
var path = '/workspace/src/app/common/ui/layout/content/content.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;